import fp from 'lodash/fp';
import queryString from 'query-string';
import React, { Component } from 'react';
import { Button, Col, Grid, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { push } from 'react-router-redux';
import { branch, compose, renderComponent, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { isPublisher, isSystemOrSuperAdmin } from '../../../../services';
import { industryActions } from '../../../../state/modules/industry';
import { publishersSelector } from '../../../../state/modules/publisher-portal/publisher/selectors';
import { currentUserSelector } from '../../../../state/modules/user';
import { BusinessLibraryFilterGroup, Icon, PublisherFilterGroup, SearchToggler } from '../../../components';
import Loading from '../../loading';
import ContentTable from './content-table';
import NonCpdContentTable from './non-cpd-content-table';

class Content extends Component {

  constructor() {
    super();

    this.state = {
      currentSorting: '',
      searchQuery: '',
      searchDebounce: null
    };
  }

  onSearchChange = (query, debounced) => ({
    searchQuery: query,
    searchDebounce: debounced
  })

  searchContent = (query) => {
    const debounced = fp.debounce(500)(() => {
      this.props.getContent(0, this.contentQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.publisherName, this.props.filters.status));
    });
    this.state.searchDebounce && this.state.searchDebounce.cancel();
    this.setState(this.onSearchChange(query, debounced))
    debounced();
  }

  componentDidMount() {
    this.props.getContent(0, this.contentQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.publisherName, this.props.filters.status));
    if (this.props.getNonCpdContent) {
      this.props.getNonCpdContent();
    }

    if ((this.props.isUserPublisher || this.props.isUserSystemAdmin) && this.props.industriesWithCpdCategorys.length === 0 && !this.props.isFetchingIndustries) {
      this.props.getIndustriesWithCpdCategorys()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      getContent,
      filters
    } = this.props
    if (!fp.isEqual(filters)(prevProps.filters)) {
      getContent(
        0,
        this.contentQuery(
          this.state.currentSorting,
          this.state.searchQuery,
          filters.publisherName,
          filters.status
        )
      )
    }
  }

  contentQuery(sorting, searchQuery, selectedPublisher, status) {
    const cpdCategorys = fp.join(',')(this.props.filters.cpdCategoryIds);
    const goals = fp.join(',')(this.props.filters.goalIds)

    return {
      cpdCategorys,
      sort: sorting,
      titleTags: searchQuery,
      publisherName: selectedPublisher,
      status: status,
      take: 50,
      goals
    };
  }

  loadMoreContent(e) {
    this.props.loadMoreContent(this.props.contentResult.content.length, this.contentQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.publisherName, this.props.filters.status));
  }

  sortBy(field, sortOrder) {
    const sortParam = sortOrder ? `${field},${sortOrder}` : '';
    this.setState({
      currentSorting: sortParam
    });
    this.props.getContent(0, this.contentQuery(sortParam, this.state.searchQuery, this.props.filters.publisherName, this.props.filters.status));
  }

  render() {
    const contentSection = <div>
      <section id='publishers--content' className='top-gap'>
        <div className="accordion--search bottom-gap">
          <Row className='button-gutter'>
            <Col xs={12} className='flexbox nowrap'>
              <span className='right-gap'>
                <SearchToggler onChange={this.searchContent} />
              </span>
              {
                this.props.business ?
                  <BusinessLibraryFilterGroup onApply={this.props.setFilters} /> :
                  <PublisherFilterGroup onApply={this.props.setFilters} />
              }
            </Col>
          </Row>
        </div>
        <div className='content-result-summary'>
          <div>
            <b>{this.props.contentResult.hits}</b>
            &nbsp;
            {this.props.contentResult.hits === 1 ? 'record' : 'records'}
          </div>
          <div>
            <b>{this.props.contentResult.hitsTotalCpdPoints}</b>
            &nbsp;
            {this.props.contentResult.hitsTotalCpdPoints === 1 ? 'CPD hour' : 'CPD hours'}
          </div>
          <div>
            <b>{this.props.contentResult.hitsTotalEstimatedReadingTime}</b>
            &nbsp;
            {this.props.contentResult.hitsTotalEstimatedReadingTime === 1 ? 'minute of reading time' : 'minutes of reading time'}
          </div>
        </div>
        <ContentTable
          hideIndustries={this.props.hideIndustries}
          contentResult={this.props.contentResult}
          isFetchingContent={this.props.isFetchingContent}
          isFetching={this.props.isFetching}
          contentDetailsRoute={this.props.contentDetailsRoute}
          getContent={this.props.getContent}
          archiveContent={this.props.archiveContent}
          deleteContent={this.props.deleteContent}
          className='table--publisher-content' updateBySorting={this.sortBy.bind(this)} currentContentQuery={this.contentQuery(this.state.currentSorting, this.state.searchQuery, this.props.filters.publisherName)} allowDelete={this.props.allowDelete} />
      </section>
      {
        this.props.contentResult.content.length < this.props.contentResult.hits ?
          <Row className='no-gutter row-slider no-background'>
            <Col xs={12} md={4} mdOffset={4}>
              <Button className='large full' onClick={(e) => this.loadMoreContent(e)}>
                Load More Content
                    </Button>
            </Col>
          </Row> :
          null
      }
    </div>
    return (
      <div className='base-layout'>
        <section id='header--publishers' className='layout--header'>
          <Grid>
            <Row className='button-gutter'>
              <Col xs={12}>
                <h1><Icon icon='caddie-links-large-alt' /> Your Content</h1>
                <p>Add or manage Content.</p>
                <p>
                  <LinkContainer className='large auto-large pushLeft' to={this.props.contentDetailsRoute}>
                    <Button>
                      <Icon icon='add-large' /> Add Content
                    </Button>
                  </LinkContainer>
                </p>
              </Col>
            </Row>
          </Grid>
        </section>
        <div id='section--publishers' className='layout--section'>
          <Grid>
            <Tabs id='content-table-tabs' defaultActiveKey='content' activeKey={this.props.contentType} onSelect={
              (contentType) => this.props.goTo({ search: `contentType=${contentType}` })
            }>
              <Tab eventKey='content' title='CPD Content'>
                {contentSection}
              </Tab>
              {
                fp.isEmpty(this.props.nonCpdContent) ?
                  null :
                  <Tab eventKey='non-cpd-content' title='Non CPD Content'>
                    <Row className='button-gutter'>
                      <Col xs={12}>
                        <NonCpdContentTable
                          hideIndustries={this.props.hideIndustries}
                          contentResult={this.props.nonCpdContent}
                          contentDetailsRoute={this.props.contentDetailsRoute}
                          getContent={this.props.getNonCpdContent}
                          archiveContent={this.props.archiveContent}
                          deleteContent={this.props.deleteContent} />
                      </Col>
                    </Row>
                  </Tab>
              }
            </Tabs>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isUserPublisher: isPublisher(currentUserSelector(state)),
  isUserSystemAdmin: isSystemOrSuperAdmin(currentUserSelector(state)),
  industryCpdCategorys: state.industry.cpdCategorys,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
  isFetching: state.cpdCategorys.isFetching,
  publishers: publishersSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
  getIndustriesWithCpdCategorys: bindActionCreators(industryActions.industries.industriesWithCpdCategorys, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ industriesWithCpdCategorys }) => industriesWithCpdCategorys.length === 0,
    renderComponent(Loading)
  ),
  withProps(
    ({ location }) => {
      const { contentType } = queryString.parse(location.search)
      return {
        contentType
      }
    }
  ),
  withProps(
    ({ isUserPublisher, isUserSystemAdmin, industryCpdCategorys, industriesWithCpdCategorys }) => ({
      cpdCategorys: (isUserPublisher || isUserSystemAdmin) ? industriesWithCpdCategorys : industryCpdCategorys
    })
  ),
  withStateHandlers(
    {
      filters: {}
    },
    {
      setFilters: () => (filters) => ({ filters })
    }
  ),
  withProps(
    ({
      filters,
      publishers
    }) => {
      const publisherName = fp.flow(
        fp.find(
          ({ id }) => id === filters.publisher
        ),
        fp.get('name')
      )(publishers)
      return {
        filters: {
          ...filters,
          publisherName
        }
      }
    }
  )
)(Content);



// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-content/content.js